import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Input, Button, Row, Col,message,
} from '@vadp/ui';
import styles from './index.less';

class Verification extends Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
    this.state = {
      inputValue: '',
    };
  }
  onChangeValue =(e) => {
    const { value } = e.target;
    this.setState({
      inputValue: value,
    });
  }
  getIdentifyingCode = () => {
    const { dispatch } = this.props;
    dispatch({ type: 'twoFactor/getCode', payload: {} });
  }

  getValidateCode = () => {
    const { inputValue } = this.state;
    const { dispatch } = this.props;
    dispatch({ type: 'twoFactor/validateCode', payload: { factorCode: inputValue } });
  }

  render() {
    const { btnDisabled, validateBtnDisabled } = this.props;
    return (
      <div className={styles.twoFactor}>
        <div className={styles.twoFactorDiv}>
          <div className={styles.twoFactorTitle}><span className={styles.title}>您正在进行登录认证</span>
            <span className={styles.title}>为了保障您的账户安全，需进行短信/邮箱密码认证</span></div>
          <div className={styles.codePart}>
            <Input placeholder={'请输入数字验证码'} className={styles.codePartInput} onChange={this.onChangeValue} />
            <div className={styles.btnWidth}>
              <Button
                className={styles.getCodeBtn}
                onClick={this.getIdentifyingCode} disabled={btnDisabled}
              >获取验证码</Button>
              <Button
                className={styles.checkCodeBtn} disabled={validateBtnDisabled}
                type="primary" onClick={this.getValidateCode}
              >验证</Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(state) {
  return {
    btnDisabled: state.twoFactor.btnDisabled,
    validateBtnDisabled: state.twoFactor.validateBtnDisabled,
  };
}
export default connect(mapDispatchToProps)(Verification);



// WEBPACK FOOTER //
// ./src/routes/Verification/index.js